if (!customElements.get('size-details-toggle')) {
  class SizeDetailsToggle extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('[role="tab"]');
      this.panels = this.querySelectorAll('[role="tabpanel"]');

      if (!this.tabs.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab));
      });
    }

    activateTab(activeTab) {
      const label = activeTab.dataset.sizeLabel;

      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.classList.toggle('size-details-toggle__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.sizeLabel === label;
        panel.classList.toggle('hidden', !isActive);
        panel.hidden = !isActive;
      });
    }

    handleKeydown(event, tab) {
      const tabs = Array.from(this.tabs);
      const currentIndex = tabs.indexOf(tab);
      let nextIndex = null;

      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          nextIndex = (currentIndex + 1) % tabs.length;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = tabs.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      const nextTab = tabs[nextIndex];
      nextTab.focus();
      this.activateTab(nextTab);
    }
  }

  customElements.define('size-details-toggle', SizeDetailsToggle);
}
